/* @jsx mdx */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsx mdx */
import ThreeGeomMat from '../interactive/ThreeGeomMat';
export const metadata = {
  demo: () => <ThreeGeomMat material={false} mdxType="ThreeGeomMat" />,
  title: 'THREE.Geometry'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`ThreeJS uses a `}<a parentName="p" {...{
        "href": "https://threejs.org/docs/#api/en/core/Geometry"
      }}>{`THREE.Geometry`}</a>{` class to hold `}<inlineCode parentName="p">{`vertices`}</inlineCode>{` (vertex positions) and `}<inlineCode parentName="p">{`faces`}</inlineCode>{` (i.e. indices).`}</p>
    <p>{`Some of the built-in geometries are shown below, such as:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://threejs.org/docs/#api/en/geometries/PlaneGeometry"
        }}>{`THREE.PlaneGeometry`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://threejs.org/docs/#api/en/geometries/BoxGeometry"
        }}>{`THREE.BoxGeometry`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://threejs.org/docs/#api/en/geometries/SphereGeometry"
        }}>{`THREE.SphereGeometry`}</a></li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
